import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { IMobile, ITelephone } from '../../model/contact-info';

export function checkNumberFormat<T extends Maybe<ITelephone> | Maybe<IMobile>>(
  data: T
) {
  const countryCode = data?.countryCode;
  const number = data?.number;
  if (!countryCode || !number) {
    return null;
  }
  return {
    countryCode,
    number,
  };
}

export function checkForNullProperties(obj: any): any {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  const allPropertiesNull = Object.values(obj).every((value) => {
    if (typeof value === 'object' && value !== null) {
      return checkForNullProperties(value) === null;
    }
    return value === null;
  });

  if (allPropertiesNull) {
    return null;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => checkForNullProperties(item));
  }

  return obj;
}
